<template>
  <NxSelectReduced
    :value="localValue"
    :options="listOptions"
    labelText="Sexo:"
    id="selectSexo"
    placeholder="Selecione o sexo"
    :multiple="false"
    @update:value="handleValueUpdate"
    :isDisabled="isDisabled"
  />
</template>
<script>
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxSelectSexo',
  mixins: [useReactiveModelMixin('value')],
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      listOptions: [
        { value: 'F', text: 'Feminino' },
        { value: 'M', text: 'Masculino' }
      ]
    }
  },
  methods: {
    handleValueUpdate (val) {
      this.localValue = val
      this.$emit('update:value', val) // Garante que o v-model funcione corretamente
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectSexo.vue